// extracted by mini-css-extract-plugin
export default {"rotatingBar":"TermsAndConditions_rotatingBar__pxe+2","rotateColors":"TermsAndConditions_rotateColors__2b62h"};